import { render, staticRenderFns } from "./FormSetRecording.vue?vue&type=template&id=a054791c"
import script from "./FormSetRecording.vue?vue&type=script&lang=js"
export * from "./FormSetRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports